import { useEffect, useState } from "react";

export function siteInitial(domain: string): string {
  const s = String(domain || "").trim().toLowerCase();
  if (!s) return "?";
  const base = s.split(".")[0] || s;
  return (base.charAt(0) || "?").toUpperCase();
}

export function siteFaviconUrl(domain: string): string {
  return `/dashboard/api/site-favicon?domain=${encodeURIComponent(String(domain || "").trim().toLowerCase())}`;
}

type SiteFaviconProps = {
  domain: string;
  className?: string;
};

export default function SiteFavicon({ domain, className = "siteSwitcherAvatar" }: SiteFaviconProps) {
  const site = String(domain || "").trim().toLowerCase();
  const letter = siteInitial(site || "?");
  const [hasFavicon, setHasFavicon] = useState(false);
  const [imgKey, setImgKey] = useState(0);

  useEffect(() => {
    setHasFavicon(false);
    setImgKey((k) => k + 1);
  }, [site]);

  return (
    <span
      className={className + (hasFavicon ? " has-favicon" : "")}
      data-site-domain={site || undefined}
    >
      {site.includes(".") ? (
        <img
          key={imgKey}
          className="siteSwitcherFavicon"
          alt=""
          decoding="async"
          referrerPolicy="no-referrer"
          loading="lazy"
          src={siteFaviconUrl(site)}
          onLoad={(e) => {
            const img = e.currentTarget;
            if (img.naturalWidth >= 4 && img.naturalHeight >= 4) setHasFavicon(true);
          }}
          onError={() => setHasFavicon(false)}
        />
      ) : null}
      <span className="siteSwitcherAvatarLetter">{letter}</span>
    </span>
  );
}
